var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 bg-white mx-1" },
    [
      _vm._m(0),
      _vm._l(_vm.services, function(service, si) {
        return _c(
          "div",
          {
            key: `service-detail-${si}`,
            staticClass: "row service-detail-row mx-1 mb-3 pt-3"
          },
          [
            _c("div", { staticClass: "col-6 col-md-4 pl-0" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Tipo de Servicio:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-14" },
                [_vm._v(" " + _vm._s(service.serviceTypeName) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-6 col-md-4" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Periodo:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-14" },
                [_vm._v(" " + _vm._s(service.period) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-6 col-md-4" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Costo:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-14" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("price")(service.costTotalAmt)) + " "
                  )
                ]
              )
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center mb-3 pt-2" }, [
      _c("i", { staticClass: "fas fa-info-circle text-orange fa-lg mr-2" }),
      _c("span", { staticClass: "color-black font-18 font-weight-bold" }, [
        _vm._v(" Detalle de Servicios ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }